import apiBolerplate from "utils/_helpers/apiBolerplate";

export async function getSupplierSurveyLoginOtp(details) {
  const data = await apiBolerplate({
    url: "/supplier_user/otp",
    bodyData: { ...details },
    hideLoader: true,
    messageType: "success",
  });

  return data || {};
}

export async function getSupplierLoginPageDetails({ token }) {
  const data = await apiBolerplate({
    url: "/supplier_user/get_login_page_details",
    bodyData: { token },
    hideLoader: true,
    hideMsg: true,
    messageType: "success",
  });

  return data || {};
}

export async function getSupplierSurveyLoginOtpValidation(details) {
  const data = await apiBolerplate({
    url: "/supplier_user/validate_otp",
    bodyData: { ...details },
    hideLoader: true,
    messageType: "success",
  });

  return data || {};
}
